var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0825 9.95565C6.42265 9.6414 5.11448 8.3394 4.79897 6.68716C4.7831 6.60428 4.66907 6.60428 4.65321 6.68716C4.33769 8.3394 3.02952 9.64178 1.36968 9.95565C1.28628 9.9714 1.28628 10.085 1.36968 10.1008C3.02952 10.415 4.33769 11.717 4.65321 13.3697C4.66907 13.4525 4.7831 13.4525 4.79897 13.3697C5.11448 11.7174 6.42265 10.415 8.0825 10.1008C8.1659 10.085 8.1659 9.97178 8.0825 9.95565Z",
    fill: "#F8AF23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.957 27.3149C101.824 27.1004 100.93 26.2109 100.715 25.0825C100.704 25.0259 100.626 25.0259 100.615 25.0825C100.399 26.2109 99.5061 27.1004 98.3725 27.3149C98.3156 27.3258 98.3156 27.403 98.3725 27.4139C99.5061 27.6284 100.399 28.5179 100.615 29.6463C100.626 29.7029 100.704 29.7029 100.715 29.6463C100.93 28.5179 101.824 27.6284 102.957 27.4139C103.014 27.4034 103.014 27.3258 102.957 27.3149Z",
    fill: "#87D147"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16499 98.5742H3.02481V97.7005C3.02481 97.0465 3.54623 96.5166 4.1898 96.5166C4.83337 96.5166 5.35479 97.0465 5.35479 97.7005V98.5742H6.21424C6.8578 98.5742 7.37923 99.1041 7.37923 99.7581C7.37923 100.412 6.8578 100.942 6.21424 100.942H5.35479V101.816C5.35479 102.47 4.83337 103 4.1898 103C3.54623 103 3.02481 102.47 3.02481 101.816V100.942H2.16499C1.52142 100.942 1 100.412 1 99.7581C1 99.1041 1.52142 98.5742 2.16499 98.5742Z",
    fill: "#70D6F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7789 3.53275C12.4671 3.53275 13.0251 2.96577 13.0251 2.26637C13.0251 1.56698 12.4671 1 11.7789 1C11.0906 1 10.5327 1.56698 10.5327 2.26637C10.5327 2.96577 11.0906 3.53275 11.7789 3.53275Z",
    fill: "#FC657E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5592 78.9995C15.2474 78.9995 15.8053 78.4326 15.8053 77.7332C15.8053 77.0338 15.2474 76.4668 14.5592 76.4668C13.8709 76.4668 13.313 77.0338 13.313 77.7332C13.313 78.4326 13.8709 78.9995 14.5592 78.9995Z",
    fill: "#F5C84C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 7.5,
    width: 81,
    height: 89,
    rx: 7.5,
    fill: "white",
    stroke: "#0D1656"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8969,
    y: 37.937,
    width: 14.1379,
    height: 11.25,
    rx: 2,
    fill: "#63BCE7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3442,
    y: 37.937,
    width: 14.1379,
    height: 11.25,
    rx: 2,
    fill: "#D40707"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3788,
    y: 37.937,
    width: 14.1379,
    height: 11.25,
    rx: 2,
    fill: "#63BCE7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8969,
    y: 54.8125,
    width: 14.1379,
    height: 11.25,
    rx: 2,
    fill: "#F8AF23"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3442,
    y: 54.8125,
    width: 14.1379,
    height: 11.25,
    rx: 2,
    fill: "#00B47B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3442,
    y: 71.688,
    width: 14.1379,
    height: 11.25,
    rx: 2,
    fill: "#63BCE7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 41.1896,
    y1: 15.937,
    x2: 41.1896,
    y2: 88.062,
    stroke: "#0D1656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 65.2239,
    y1: 15.937,
    x2: 65.2239,
    y2: 88.062,
    stroke: "#0D1656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.3969,
    y1: 29,
    x2: 84.0175,
    y2: 29,
    stroke: "#0D1656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBoard);
export default __webpack_public_path__ + "static/media/empty-board.173a807c7dc74f8ddbff454f3629df38.svg";
export { ForwardRef as ReactComponent };